<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.event.menu"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.event.list.title"></app-i18n>
      </h1>

      <app-event-list-toolbar></app-event-list-toolbar>
      <app-event-list-filter></app-event-list-filter>
      <app-event-list-table></app-event-list-table>
    </div>
  </div>
</template>

<script>
import EventListFilter from '@modules/event/components/event-list-filter.vue';
import EventListTable from '@modules/event/components/event-list-table.vue';
import EventListToolbar from '@modules/event/components/event-list-toolbar.vue';

export default {
  name: 'app-event-list-page',

  components: {
    [EventListFilter.name]: EventListFilter,
    [EventListTable.name]: EventListTable,
    [EventListToolbar.name]: EventListToolbar,
  },
};
</script>

<style>
</style>
